
<div class="col-sm-12 p-4"   >
    <div class="page-body m-0">
        <div class="container-fluid">
            <!-- *ngIf="caseObject!=null && caseObject.caseStatusId<8" -->
            <div>
                <div class="row">
                    <div class="row col-12">
                        <div class="card">
                            <div class="col-3 mt-3 mb-1">
                                <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                                    <label for="">{{'Suggestiondecision' | translate}}</label>
                                    <span *ngIf="descValid.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 0px;">
                                        <div *ngIf="descValid.errors?.required">
                                        *
                                        </div>
                                    </span>
                                </div>
                            </div>
                           
                            <textarea rows="10" [(ngModel)]="SuggestionDecision" class="form-control"
                                name="SuggestionDecision"  #descValid="ngModel" required></textarea>
                            <br />
                            <div class="col-lg-12">
                                <div class="form-group row">
                                    <div class="col-6" style="width: 40%;"></div>
                                   
                                    <div class="col-2">
                                        <button (click)="saveSuggestionDecision();" [disabled]="descValid.invalid"
                                                class="btn btn-primary">
                                          <i class="fa fa-save"></i> 
                                            {{'Save' | translate}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


